/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A data entry in an analysis model. Serves as an anchor for the underlying tables.
 */
export interface AnalyticValue { 
    /**
     * Internal AnalyticValue Key
     */
    id?: number;
    /**
     * Internal AnalyticProcess Key
     */
    analyticProcessId?: number;
}

